import axios from 'axios';
import { getLoadAssetsUrl } from '../../../../util/util';

const loadAssetsClient = axios.create({});

loadAssetsClient.interceptors.request.use(async (config) => {
	config.baseURL = getLoadAssetsUrl();
	return config;
});

export default loadAssetsClient;
